<template>
     
    <div class="px-2" style="{backgruond-color:white}">
      <HeaderBar/>
      <!-- search input -->
  
      <div class="d-flex justify-content-center mt-1 headTitle mt-4">
        Animales inactivos
      </div>
      <div class="d-flex justify-content-center mt-1 headTitle">
        {{fincaName}}
      </div>
      
      <!-- table -->
      
      <vue-good-table :columns="columns" :rows="rows" :rtl="direction"  styleClass="vgt-table bordered"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm
        }" 
        
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
          mode:'records',
          nextLabel: ' Sig ',
          prevLabel: ' Ant ',
          perPageDropdown: [10, 20],
          dropdownAllowAll: false,
          rowsPerPageLabel: 'Registros por página',
          ofLabel: 'de',
          position: 'top',
          pageLabel: 'página',
        }"
        
        :sort-options="{
          enabled: true,
        }"
  
        @on-row-click="showModal"
      >
        <template slot="table-row" slot-scope="props">
  
          <!-- Column: Name -->
          <span v-if="props.column.field === 'sex'" class="text-center">
            <span v-if="props.row.sex===false" class="text-center">M</span>
            <span v-if="props.row.sex===true" class="text-center">H</span>
            
          </span>
  
          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'status'">
            <b-badge :variant="statusVariant(props.row.status)">
              {{ props.row.status }}
            </b-badge>
          </span>
  
          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
  
        <!-- pagination -->
        <!-- <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Mostrando 1 de
              </span>
              <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> of {{ props.total }} registros </span>
            </div>
          </div>
        </template> -->
      </vue-good-table>
      
      <b-modal centered v-model="modalShow" hide-footer hide-header>
        <div v-if="modalCase == 0">
          <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex align-items-center justify-content-center subTitle pt-2 ">Animales
  
  
          </div>
          <div class="linkTitle mt-5" @click="modalCase = 1">Datos Generales</div>
          <div class="linkTitle mt-2" @click="modalCase = 2">Evolucion Peso</div>
          <div class="linkTitle mt-2" @click="modalCase = 3">Datos Sanitarios</div>
          <div class="linkTitle mt-2 mb-5" @click="modalCase = 4">Datos Reproductivos</div>
        </div>
  
  
        <div v-if="modalCase == 1">
          <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Generales</div>
          <div class=" d-flex justify-content-end  border-bottom">
            <feather-icon @click="modalCase=5" icon="Edit2Icon" size="20" />
            <!-- <feather-icon class="" @click="modalTrashShow = !modalTrashShow" icon="TrashIcon" size="20" /> -->
          </div>
          <div class="d-flex align-items-center justify-content-center pt-2">
            <b-img :src="this.$filesUrl+animalData.image_url" width="200"/>
          </div>
          <div class="d-flex align-items-center justify-content-center pt-2">
            {{animalData.number}} - {{animalData.name}}
          </div>
              
            
          <div class="d-flex justify-content-between mt-3 ">
            
            <div class="ml-2">Peso <p class="editModal">{{animalData.weight}}</p> </div> 
            <div class="mr-5 pr-3">Edad <br /><p class="editModal"> {{animalData.age}} </p></div>
          </div>
           <div class="mt-1 ml-2">Sexo <p v-if="animalData.sex===false" class="editModal"> Macho</p> <p v-if="animalData.sex===true" class="editModal"> Hembra</p></div>
           <!-- <div class="d-flex justify-content-center mb-5 mt-3">
            <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img>
           </div> -->
        </div>
          <div v-if="modalCase==5">
           <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Generales</div>
            <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
            <div class="d-flex justify-content-center mt-2">
  
              <b-form-group class="w-25" label="Peso" label-for="weight">
                  <b-form-input id="animal.weight" v-model="animal.weight" :value="animalData.weight"/>
              </b-form-group>
              <b-form-group class="w-75 ml-1" label="Edad" label-for="age">
                  <b-form-input id="animal.age" v-model="animal.age" :value="animalData.age" />
              </b-form-group>
            </div>
            <b-form-group label="Sexo" label-for="sex">
              <div class="d-flex align-items-center justify-content-center">
                <div class="flex-column pt-0 mr-2">Macho</div>
                  <div class="align-self-end mr-2">
                    <b-form-checkbox
                      v-model="animal.sex"
                      button-variant="#D7B92C"
                      class="custom-control-warning"
                      name="check-button"
                      switch
                    />
                    
                  </div>
                <div class="flex-column">Hembra</div>
              </div>
            </b-form-group>
            
           
          <!--   <div class="d-flex justify-content-center  mt-2">
            <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img>
            </div> -->
           
           <div class="d-flex justify-content-center  mt-2 mb-1"><b-button @click="updateAnimal" class="bg-primary w-50"> Guardar</b-button></div>
          
          </div>
           <!--////////////// -->
           <div v-if="modalCase == 2">
          <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex align-items-center justify-content-center subTitle pt-2">Evolucion Peso</div>
          <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
          <!-- <div class=" d-flex justify-content-end  border-bottom">
            <feather-icon  icon="PlusIcon" size="20" />
          </div> -->
          <div class="d-flex justify-content-between mt-3 ">
            <WheighinsLineChartVue
  
              :data="weighinsData"
              :options="chartOptions"
            />
          </div>
          
        </div>
          <!--////////////// -->
         <div v-if="modalCase == 3">
          <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Sanidad</div>
          <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
          <!-- <div class=" d-flex justify-content-end  border-bottom">
            <feather-icon @click="modalCase=7" icon="Edit2Icon" size="20" />
            <feather-icon class="" @click="modalTrashShow = !modalTrashShow" icon="TrashIcon" size="20" />
          </div> -->
          <div class="d-flex justify-content-between mt-3 ">
            <div class="ml-1">Vacunacion <p class="editModal"><a :href="'/basicHome/Animals/Vaccines/'+this.currAnimal">{{ vaccinations }}</a></p> </div> 
            <div class="mr-3">Desparacitaciones <p class="editModal"><a :href="'/basicHome/Animals/Dewormings/'+this.currAnimal">{{dewormings}}</a></p></div>
          </div>
          <div class="d-flex justify-content-between mt-1">
            <div class=" ml-1">Tratamientos <p class="editModal"><a :href="'/basicHome/Animals/Treathments/'+this.currAnimal">{{treathments}}</a></p></div>
             <div class=" mr-3">Alerta <p class="editModal"><a :href="'/basicHome/Animals/Alerts/'+this.currAnimal">{{ alerts }}</a></p></div>
          </div>
           <!-- <div class="d-flex justify-content-center mb-5 mt-3">
            <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img>
           </div> -->
        </div>
        <!--////////////// -->
          <div v-if="modalCase==7">
           <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Sanidad</div>
          <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
            <div class="d-flex justify-content-center mt-2">
  
              <b-form-group class="w-25" label="Vacunacion" label-for="reproduction">
                  <b-form-input id="reproduction"/>
              </b-form-group>
              <b-form-group class="w-75 ml-1" label="Desparacitaciones" label-for="part">
                  <b-form-input id="part" />
              </b-form-group>
            </div>
            <div class="d-flex justify-content-center mt-1">
              <b-form-group class="w-50" label="Tratamientos" label-for="abortion">
                  <b-form-input id="abortion" />
              </b-form-group>
               <b-form-group class="w-50" label="Alerta" label-for="palpation">
                  <b-form-input id="palpation" />
              </b-form-group>
            </div>
          <div class="d-flex justify-content-center  mt-2">
           <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img></div>
           
           <div class="d-flex justify-content-center  mt-2 mb-1"><b-button class="bg-primary w-50"> Guardar</b-button></div>
          
          </div>
          <!--////////////// -->
          <div v-if="modalCase == 4">
          <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Reproduccion</div>
          <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
            <div class="d-flex justify-content-between mt-3 " v-if="animalData.sex==true">
              <div class="ml-2">Reproduccion <p class="editModal">0</p> </div> 
              <div class="mr-5 pr-3">Partos <p class="editModal"> 0</p></div>
            </div>
            <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==true">
              <div class=" ml-2">Abortos <p class="editModal"> 0</p></div>
              <div class=" mr-5">Palpaciones <p class="editModal"> 0</p></div>
            </div>
  
            <div class="d-flex justify-content-between mt-1" v-if="animalData.sex==false">
              <div class=" ml-2">Andrología <p class="editModal"> 0</p></div>
            </div>
        </div>
        <!--////////////// -->
          <div v-if="modalCase==6">
           <div class="d-flex justify-content-end  ">
            <feather-icon @click="modalShow = !modalShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex align-items-center justify-content-center subTitle pt-2">Datos Reproduccion</div>
          <div class="editAnimal mt-2"><strong>Animal:</strong> {{animalData.number}} - {{animalData.name}}</div>
            <div class="d-flex justify-content-center mt-2">
  
              <b-form-group class="w-25" label="Reproduccion" label-for="reproduction">
                  <b-form-input id="reproduction"/>
              </b-form-group>
              <b-form-group class="w-75 ml-1" label="Partos" label-for="part">
                  <b-form-input id="part" />
              </b-form-group>
            </div>
            <div class="d-flex justify-content-center mt-1">
              <b-form-group class="w-50" label="Abortos" label-for="abortion">
                  <b-form-input id="abortion" />
              </b-form-group>
               <b-form-group class="w-50" label="Palpaciones" label-for="palpation">
                  <b-form-input id="palpation" />
              </b-form-group>
            </div>
          <div class="d-flex justify-content-center  mt-2">
           <b-img src="@/assets/images/ganImage/UpoladImage.png" ></b-img></div>
           
           <div class="d-flex justify-content-center  mt-2 mb-1"><b-button class="bg-primary w-50"> Guardar</b-button></div>
          
          </div>
        <b-modal class="modal-lg" centered v-model="modalTrashShow" hide-footer hide-header>
          <div class="d-flex  align-items-end justify-content-end">
            <feather-icon @click="modalTrashShow = !modalTrashShow" icon="XIcon" size="20" />
          </div>
          <div class="d-flex flex-column align-items-center justify-content-center">
            <span class="deleteModal mt-2"> ¿Desea eliminar? </span>
            <b-button class="bg-deleteButton mt-2 mb-2">Eliminar</b-button>
          </div>
        </b-modal>
  
      </b-modal>
      
      <ControlMenu />
    </div>
  </template>
  
  <script>
  import ControlMenu from '@/components/ControlMenu.vue'
  import HeaderBar from '@/components/HeaderBar.vue'
  import AddButton from '@/components/AddButton.vue'
  import vSelect from 'vue-select'
  import "vue-select/dist/vue-select.css";
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import {
    BAvatar, BBadge, BPagination, BFormGroup, BFormSelect, BFormCheckbox, BDropdown, BDropdownItem, BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormInput, BInputGroup, BImg, BCardTitle, BCardText,
  } from 'bootstrap-vue'
  import { VueGoodTable } from 'vue-good-table'
  import PlusButton2 from '@/components/PlusButton2.vue'
  import store from '@/store/index'
  import WheighinsLineChartVue from '../DataLog/Animal/WheighinsLineChart.vue';
  
  export default {
    components: {
      BRow,
      BImg,
      BCol,
      BLink,
      BButton,
      BForm,
      BCardText,
      BCardTitle,
      BFormCheckbox,
      BInputGroup,
      BCardBody,
      BCard,
      VueGoodTable,
      vSelect,
      PlusButton2,
      ValidationProvider,
      ValidationObserver,
      BFormCheckbox,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      ControlMenu,
      HeaderBar,
      AddButton,
      WheighinsLineChartVue,
    },
    data() {
      return {
        fincaName:localStorage.getItem('currentFarmName'),
        currAmimal:0,
        pageLength: 10,
        dir: false,
        status1: null,
        status2: null,
        modalShow: false,
        modalCase: 0,
        editShow:false,
        modalTrashShow:false,
        columns: [
          {
            label:  'CODIGO',
            field:  'number',
            type:   'string'
          },  
          {
            label:  'ANIMAL',
            field:  'name',
            type:   'string'
          },
          {
            label:  'SEXO',
            field:  'sex',
            type:   'boolean'
          },
          {
            label:  'PESO',
            field:  'weight',
            type:   'number'
          },
          {
            label:  'EDAD',
            field:  'age',
            type:   'number'
          },
          {
            label:  'MOTIVO',
            field:  'reason',
            type:   'string'
          }
  
        ],
        rows: [],
        animalData:[],
        animal:{
          weight:0,
          age:0,
        },
        weighinsData:{
          labels:[],
          datasets: [
            { label:'Evolución de peso',
              backgroundColor: '#5E8F23',
              data:[]
            }
          ]
        },
        chartOptions:{
          responsive: true,
          maintainAspectRatio: false,
          backgroundColor: false,
          hover: {
            mode: 'label',
          },
          layout: {
            padding: {
              top: 0,
              bottom: 0,
              left: 0,
              right:20
            },
          },
          
          legend: {
            position: 'top',
            align: 'start',
            labels: {
              usePointStyle: true,
              padding: 25,
              boxWidth: 9,
            },
          },
        },
        weighins:{
          observations:'',
          animal_id:this.currAmimal,
          weight:0,
          date:''
        },
        searchTerm: '',
        vaccionations:0,
        dewormings:0,
        treathments:0,
        alerts:0,
      }
    },
    computed: {
      statusVariant() {
        const statusColor = {
          /* eslint-disable key-spacing */
          Current: 'light-primary',
          Professional: 'light-success',
          Rejected: 'light-danger',
          Resigned: 'light-warning',
          Applied: 'light-info',
          /* eslint-enable key-spacing */
        }
  
        return status => statusColor[status]
      },
      direction() {
        if (store.state.appConfig.isRTL) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.dir = true
          return this.dir
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = false
        return this.dir
      },
    },
    methods:{
      async fetchAnimals(config){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/AnimalExitsWithReason?recperpage=all&farm_id="+farmId+"&state=0", config)
          .then(response => response.json())
          .then(result => {
              console.log(result.AnimalExitsWithReason);
              this.rows = result.AnimalExitsWithReason.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age,reason:item.reason}});
              console.log(this.AnimalExitsWithReason);
          })
      },
  
      async fetchAnimalData(config){
        let id= this.currAnimal;
        fetch(this.$apiUrl+"view/animals/"+id, config)
          .then(response => response.json())
          .then(result => {
              console.log(result);
              this.animalData = result.animals;
              this.animal= result.animals;
              console.log(this.animalData);
          })
      },
  
      async fetchAnimalWheihins(config){
        let id= this.currAnimal;
          fetch(this.$apiUrl+"list/weighins?animal_id="+id+"&order=date&ordertype=ASC", config)
          .then(response => response.json())
          .then(result => {
              console.log(result);
              this.weighinsData.labels= result.weighins.map(item => {return item.date});
              this.weighinsData.datasets[0].data = result.weighins.map(item => {return item.weight});
              console.log(this.weighinsData);
          })
      },
  
      async fetchAnimalVacinations(config){
        let id= this.currAnimal;
        let self=this;
        this.vaccinations=0;
        let vacs=[];
          fetch(this.$apiUrl+"list/vaccinationsbyanimals?animal_id="+id, config)
          .then(response => response.json())
          .then(result => {
              console.log(result);
              result.VaccinationsByAnimals.map(item => {
                if(item.animal_id==id){
                  
                  vacs.push(item)
                  console.log(vacs)
                  this.vaccinations=(parseInt(vacs.length))
                  console.log(this.vaccinations)
                }
              })
  
          })
      },
      async fetchAnimalDewormings(config){
        let id= this.currAnimal;
        let self=this;
        this.dewormings=0;
        let vacs=[];
          fetch(this.$apiUrl+"list/demormerbyanimals?animal_id="+id, config)
          .then(response => response.json())
          .then(result => {
              console.log(result);
              result.DemormerbyAnimals.map(item => {
                if(item.animal_id==id){
                  
                  vacs.push(item)
                  console.log(vacs)
                  this.dewormings=(parseInt(vacs.length))
                  console.log(this.dewormings)
                }
              })
  
          })
      },
      async fetchAnimalTreathments(config){
        let id= this.currAnimal;
        let self=this;
        this.treathments=0;
        let vacs=[];
          fetch(this.$apiUrl+"list/treathmentsbyanimals?animal_id="+id, config)
          .then(response => response.json())
          .then(result => {
              console.log(result);
              result.TreathmentsByAnimals.map(item => {
                if(item.animal_id==id){
                  
                  vacs.push(item)
                  console.log(vacs)
                  this.treathments=(parseInt(vacs.length))
                  console.log(this.treathments)
                }
              })
  
          })
      },
  
      updateAnimal(){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        let id= this.currAnimal;
        this.$http.post("edit/animals/"+id, this.animal, config).then(()=>{
          /* this.animal={
            weight:0,
            age:0,
            sex:0,
          } */
  
          this.$swal({
            title: 'Actualización de Animal',
            text: 'Se actualizó animal de manera satisfactoria',
            type: 'success',
            icon:'success',
            showCancelButton: false,
            confirmButtonColor:'#5E8F23',
            showCloseButton: true,
            showLoaderOnConfirm: false  
          }).then(function(){
  
  
          });
        }).catch(error => {
          console.log(error)
        });
      },
  
      insertWheigning(){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        let id= this.currAnimal;
        this.$http.post("add/weighins/"+id, this.weighins, config).then(()=>{
          this.weighins={
            observations:'',
            animal_id:this.currAmimal,
            weight:0,
            date:''
          },
  
          this.$swal({
            title: 'Pesaje',
            text: 'Se insertó el peso del animal de manera satisfactoria',
            type: 'success',
            icon:'success',
            showCancelButton: false,
            confirmButtonColor:'#5E8F23',
            showCloseButton: true,
            showLoaderOnConfirm: false  
          }).then(function(){
  
  
          });
        }).catch(error => {
          console.log(error)
        });
      },
  
      showModal(params){
        console.log(params);
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        console.log(params.row.id);
        this.currAnimal=params.row.id;
        console.log(this.currAnimal);
        this.fetchAnimalData(config);
        this.fetchAnimalWheihins(config);
        this.fetchAnimalVacinations(config);
        this.fetchAnimalDewormings(config);
        this.fetchAnimalTreathments(config);
        this.modalShow=true;
        this.modalCase=0;
      },
    },
    created() {
      const token = localStorage.getItem("accessToken");
      const config = {headers: {"X-Authorization": `Bearer ${token}`}};
      this.fetchAnimals(config);
    },
  }
  </script>
  <style lang="scss">
  body {
    background-color: white !important;
  }
  table{
      width: 100% !important;
    }
  .subTitle {
    font-weight: 600;
    font-size: 23px;
  
  }
  
  .linkTitle {
  
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.4px;
    color: #5E8F23;
  
  }
  
  .headTitle {
    font-weight: 600;
    font-size: 24px;
    color: #5E8F23;
  }
  
  thead{
    background-color: #5E8F23;
    text-align:center;
    color:#ffffff;
  }
  thead> tr{
    padding:5px;
  }
  .editAnimal {
    font-weight: 500;
    font-size: 18px;
  }
  
  
  .editModal {
    font-weight: 500;
    font-size: 18px;
  }
  
  span.text-center{
    display:flex;
    justify-content: center;
    text-align: center;
  }
  </style>